export default "__VITE_ASSET__CUPpK6cu__"